import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { AirportFragment } from '@websky/graphql';

import { Land, Takeoff } from './../../../Icons/Icons';
import { useTranslation } from 'react-i18next';

interface Props {
	time: string;
	airport: AirportFragment;
	terminal?: string;
	departure?: boolean;
	mobile?: boolean;
}

const FlightInfoCardPoint: React.FC<Props> = ({ time, airport, terminal, departure, mobile }) => {
	const { FlightInfoCardPoint: css } = useTheme('FlightInfoCard');

	const { t } = useTranslation('FlightInfoCard');

	return !mobile ? (
		<div className={cn(css.wrapper, { [css.wrapper_departure]: departure })}>
			<div className={cn(css.airport, { [css.airport_departure]: departure })}>
				<div>{airport.title}</div>
				<div>{terminal && `${t('Terminal')} ${terminal}`}</div>
			</div>
			<div className={cn(css.time)}>{time}</div>
		</div>
	) : (
		<div className={cn(css.wrapper_mobile)}>
			<div className={cn(css.plane)}>{departure ? Takeoff : Land}</div>
			<div className={cn(css.time)}>{time}</div>
			<div className={cn(css.airport)}>
				{airport.title}
				{terminal && (
					<>
						,{' '}
						<span className={css.airport_terminal}>
							{t('Terminal')} {terminal}
						</span>
					</>
				)}
			</div>
		</div>
	);
};

export default FlightInfoCardPoint;
